export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: state => state.all,
    loading: state => state.loading
  },
  mutations: {
    setAll(state, actionItems) {
      state.all = actionItems
      state.loading = false
    }
  },
  actions: {
    fetchAll({ state, commit }) {
      state.loading = true
      return Vue.$http
        .get('candidate/action_items')
        .then(response => commit('setAll', response.data), () => (state.loading = false))
    }
  }
}
